import React from 'react';
import ArrowDropDownFilled from '../../Icons/ArrowDropDownFilled';
import CalendarTodayOutlined from '../../Icons/CalendarTodayOutlined';
import ChevronLeftFilled from '../../Icons/ChevronLeftFilled';
import ChevronRightFilled from '../../Icons/ChevronRightFilled';
import DateRangeFilled from '../../Icons/DateRangeFilled';
export default function DatePicker(theme) {
    const commonStyle = {
        borderRadius: 2,
        'div[role="presentation"]': {
            maxHeight: 35
        }
    };
    const mobileSlotProps = {
        actionBar: {
            sx: {
                px: 2
            }
        },
        toolbar: {
            sx: {
                '& .MuiDatePickerToolbar-title': {
                    color: theme.palette.text.primary
                }
            }
        },
        calendarHeader: {
            slots: {
                leftArrowIcon: ChevronLeftFilled,
                rightArrowIcon: ChevronRightFilled,
                switchViewIcon: ArrowDropDownFilled
            }
        }
    };
    return {
        MuiDateTimePicker: {
            defaultProps: {
                slots: {
                    openPickerIcon: CalendarTodayOutlined
                },
                showToolbar: true,
                mobilePaper: {
                    sx: {
                        ...commonStyle
                    }
                }
            }
        },
        MuiDesktopDateTimePicker: {
            defaultProps: {
                slots: {
                    openPickerIcon: CalendarTodayOutlined
                },
                showToolbar: true,
                desktopPaper: {
                    sx: {
                        ...commonStyle
                    }
                }
            }
        },
        MuiMobileDateTimePicker: {
            defaultProps: {
                ampmInClock: true,
                slotProps: {
                    ...mobileSlotProps,
                    tabs: {
                        dateIcon: /*#__PURE__*/ React.createElement(DateRangeFilled, null),
                        sx: {
                            '& .Mui-selected': {
                                color: theme.palette.primary.main
                            },
                            '& .MuiTab-root': {
                                background: 'none'
                            }
                        }
                    },
                    mobilePaper: {
                        sx: {
                            '& .MuiDateTimePickerToolbar-dateContainer': {
                                rowGap: theme.spacing(0.75),
                                marginTop: theme.spacing(0.5)
                            },
                            ...commonStyle
                        }
                    }
                },
                slots: {
                    openPickerIcon: CalendarTodayOutlined
                },
                showToolbar: true
            }
        },
        MuiDatePicker: {
            defaultProps: {
                slots: {
                    openPickerIcon: CalendarTodayOutlined
                },
                mobilePaper: {
                    sx: {
                        ...commonStyle
                    }
                },
                desktopPaper: {
                    sx: {
                        ...commonStyle
                    }
                }
            }
        },
        MuiDesktopDatePicker: {
            defaultProps: {
                slots: {
                    openPickerIcon: CalendarTodayOutlined
                },
                desktopPaper: {
                    sx: {
                        ...commonStyle
                    }
                }
            }
        },
        MuiMobileDatePicker: {
            defaultProps: {
                slotProps: {
                    ...mobileSlotProps
                },
                slots: {
                    openPickerIcon: CalendarTodayOutlined
                }
            }
        },
        MuiTimePicker: {
            defaultProps: {}
        },
        MuiDesktopTimePicker: {
            defaultProps: {}
        },
        MuiMobileTimePicker: {
            defaultProps: {}
        }
    };
}
